import { useMutation, useQueryCache } from 'react-query';
import { EventAPI } from 'api/admin/event';
import { EVENTS } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useCreateEvent() {
  const queryCache = useQueryCache();

  return useMutation(EventAPI.addEvent, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      dispatchToast({ message, type: 'success' });
      queryCache.invalidateQueries(EVENTS);
      onSuccess();
    },
  });
}
